<template>
    <span>
        <div class="MInputContent">
            <p>
                <label :for="'MInput'+tag">{{title}}</label>
            </p>
            <p class="MInput">
                <input :id="'MInput'+tag"
                       :maxlength="max"
                       :type="type || 'text'" :disabled="disabled"
                       @input="changeModel"
                       v-model="val"
                       :class="{'padding20': rightIcon}"
                       :placeholder="pla">
            </p>
            <Svgs v-if="rightIcon" color="#90939A" class="right-icon" name="iconiconfontleft"></Svgs>
        </div>
    </span>
</template>

<script>
    export default {
        name: "MInput",
        props: ['title', 'pla', 'value', 'disabled', 'max', 'type', 'rightIcon'],
        data() {
            return {
                val: '',
                tag: '',
            }
        },
        watch: {
            'value': function () {
                this.val = this.value;
            }
        },
        model: {
            prop: 'value',
            event: 'change'
        },
        created() {
            this.tag = new Date().getTime();
        },
        methods: {
            changeModel() {
                this.$emit('change', this.val);
            }
        }
    }
</script>

<style scoped>
    .MInputContent {
        padding: 0 0.26rem;
    }

    .MInputContent p {
        text-align: left;
        color: #90939A;
    }

    .padding20 {
        padding-right: 0.52rem;
        box-sizing: border-box;
    }

    .MInput {
        border-bottom: 1px solid #F5F5F5;
        margin-bottom: 0.08rem;
    }

    .right-icon {
        position: absolute;
        right: 0.26rem;
        bottom: 0.04rem;
    }

    .MInput input {
        height: 0.32rem;
        line-height: 0.32rem;
        text-align: left;
        width: 100%;
        outline: none;
        color: #13161B;
        background: #fff;
        border: 0;
    }
</style>